import Mutations from '../../odata/mutations';

export default { ...new Mutations('softSaleStockItem'), ...new Mutations('softSaleStockItems') };
